import { Account, AccountSession } from "../models/user"

const cacheKey = "hg::cache::user"

// The cache nominally holds an AccountSession, but the post-payment redirect
// flow writes either a full Account or a bare { access_token } into the same
// slot. Reads only ever touch access_token / session_id / expires / is_signed_up.
type CachedUserPayload = AccountSession | Account | { access_token: string }

export const setCachedUser = (user: CachedUserPayload) => {
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return
  }
  localStorage.setItem(cacheKey, JSON.stringify(user))
}

export const removeCachedUser = () => {
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return
  }
  localStorage.removeItem(cacheKey)
}

export const getCachedUser = (): AccountSession | null => {
  if (typeof window === "undefined" || typeof localStorage === "undefined") {
    return null
  }
  const raw = localStorage.getItem(cacheKey)
  return raw ? (JSON.parse(raw) as AccountSession) : null
}
